import React, { useCallback, useEffect, useRef, useState } from 'react';
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import { themeButtons } from "../../../css/themeButtons";
import { ReactSortable } from "react-sortablejs";
import { Field, Form, Formik } from "formik";
import Modal from "../../common/Modals/Modal";
import TextField from "@material-ui/core/TextField";
import Box from "@material-ui/core/Box";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Collapse from "@material-ui/core/Collapse";
import { useMediaQuery } from "@material-ui/core";
import { useQuery } from "../../common/CustomHook/useQuery";
import { useParams } from "react-router-dom";
import imageCompression from 'browser-image-compression';

const RenderPhotoList = ({
  photoApproved,
  updatePhotoSort,
  addToNotApproved,
  deletePhotoAcceptInModal,
  uploadPhoto,
  baseUrl,
  handleUnsavedPage,
  userRole
}) => {
  const mobileAgent = useMediaQuery('(max-width: 974px)') || window.matchMedia('(max-width: 974px)').matches;
  const htmlElRef = useRef(null)

  /**
   * Перенаправление клика
   */
  const addClick = useCallback((e) => {
    e.preventDefault();
    htmlElRef.current && htmlElRef.current.click();
  }, [htmlElRef]);


  const buttons = themeButtons();
  return (
    <>

      <input id="file" multiple name="file" accept="image/jpeg,image/png,image/jpg,image/tiff" type="file"
             ref={htmlElRef} onChange={uploadPhoto} className="d-none"/>


      <ReactSortable animation={500} draggable=".card-sortable"
                     id="sortable"
                     disabled={mobileAgent}
                     onChange={handleUnsavedPage}
                     className="row cards-object row-cols-3 row-cols-xl-4 row-cols-xxl-5 g-2"
                     list={photoApproved} setList={updatePhotoSort}>
        {photoApproved.map((item, index) => (
          <div key={index} className={`col ${index !== 0 && "card-sortable"}`}>
            {index === 0
              ? <Card onClick={addClick} className="card add-card card-object-photo h-100">
                <CardActionArea className="d-flex w-100 h-100">
                  <CardContent className="add-object__icon">
                    <FontAwesomeIcon icon={["fas", "plus"]}/>
                  </CardContent>

                  <CardContent>
                    <Typography className="add-object__text text-center" variant="h6">
                      Добавить фотографии

                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>

              : <Card className="card card-photo active h-100">
                <Button onClick={() => deletePhotoAcceptInModal(item.id, "photoApproved")}
                        className="btn card-delete">
                  <FontAwesomeIcon icon={"trash"}/>
                </Button>
                <CardMedia
                  image={`${item.id.split("-")[0] !== "new" ? baseUrl : ""}${item.src}`}
                  className="card-img w-100 h-100"
                />
                {userRole === "MODERATOR" && <div className="function-btns toggle">
                  <Button onClick={() => addToNotApproved(item.id)}
                          className={`btn ${buttons.btnDanger} mt-1`}>
                    Отказать
                  </Button>
                </div>}

              </Card>
            }
          </div>

        ))}

      </ReactSortable>
    </>
  )
}

const RenderNotApprovedFotoCard = ({
  photoNotApproved,
  viewFalilureMessage,
  deletePhotoAcceptInModal,
  removeToPhotoApproved,
  baseUrl
}) => {
  const buttons = themeButtons();
  return (
    <div className="row cards-object row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xl-4 row-cols-xxl-5 g-2 mb-3">
      {photoNotApproved.map((item, index) => (
        <div key={index} className="col">
          <Card className="card card-photo h-100">
            <Button onClick={() => deletePhotoAcceptInModal(item.id, "photoNotApproved")}
                    className="btn card-delete">
              <FontAwesomeIcon icon={"trash"}/>
            </Button>
            <CardMedia
              image={`${item.id.split("-")[0] !== "new" ? baseUrl : ""}${item.src}`}
              className="card-img w-100 h-100"
            />
            <div className="function-btns">
              <Button onClick={() => viewFalilureMessage(item.failure)}
                      className={`btn ${buttons.btnLight} mt-1`}>Узнать
                причину
              </Button>
              <Button onClick={() => removeToPhotoApproved(item.id)}
                      className={`btn ${buttons.btnGreen} mt-1`}>
                Опубликовать
              </Button>
            </div>
          </Card>
        </div>

      ))}
    </div>

  )
}

const RenderModalAddFailureMessageModal = ({ toggleShow, show, onSubmit }) => {
  return (
    <Formik initialValues={{}}
            onSubmit={onSubmit}>
      {({ handleSubmit, values }) => (
        <Form onSubmit={handleSubmit}>
          <Modal toggleShow={toggleShow} show={show} title={"Отказ в публикации фотографии"}
                 textBtnOk={"Применить"} btnOkAction={handleSubmit}>
            <div className="row">
              <div className="col-12 mb-3">
                <span>Вы уверены, что хотите отказать в публикации фото? (отельер будет оповещен, обязательно укажите причину отказа)</span>

              </div>
              <div className="col-12">

                <Field name="failure">
                  {({ field }) => (
                    <TextField
                      label="Причина отказа *"
                      multiline
                      name={field.name}
                      onChange={field.onChange}
                      fullWidth
                      rows={4}
                      variant="outlined"
                      inputProps={{ maxLength: 2000 }}
                      helperText="* - обязательно для заполнения!"
                    />
                  )}
                </Field>
              </div>
            </div>

          </Modal>
        </Form>
      )}
    </Formik>
  )
}

const RenderModalFailureMessage = ({ toggleShow, show, failureMessage }) => {
  return (
    <Modal toggleShow={toggleShow} show={show} title={"Причина отказа от публикации"}
           textBtnOk={"Понятно"}>
      <div className="row">
        <div className="col-12">
          <p>{failureMessage}</p>
        </div>
      </div>

    </Modal>
  )
}

const RenderModalDeletePhoto = ({ toggleShow, show, action, deletedPhotoImg, baseUrl }) => {

  return (
    <Modal className="modal" toggleShow={toggleShow} show={show} title={"Удалить выбранную фотографию?"}
           textBtnOk={"Удалить"} btnOkAction={action} textBtnCancel={"Отмена"}>
      <div className="d-flex justify-content-center">
        <img className="delete-photo__img"
             src={deletedPhotoImg.split(":")[0] === "data" ? deletedPhotoImg : baseUrl + deletedPhotoImg}
             alt=""/>
      </div>

    </Modal>
  )
}

const RoomPhoto = (props) => {
  const {
    roomPhotoApprovedToDB,
    roomPhotoNotApprovedToDB,
    roomIdByProps,
    baseUrl,
    handleChangeUploadPhoto,
    handleChangePhoto,
    handleChangeRejectedPhoto,
    handleChangeDeletedPhoto,
    errors,
    setSizeAlert,
    userRole
  } = props
  const query = useQuery();
  const params = useParams()
  const roomId = params.roomId || query.get("room")

  useEffect(() => {
    if (roomIdByProps !== roomId) {
      setPhotoApproved([{}])
      setPhotoNotApproved([])
    }
  }, [roomId, roomIdByProps])

  const [photoApproved, setPhotoApproved] = useState([{}]);
  const [photoNotApproved, setPhotoNotApproved] = useState([]);
  const [addIdPhotoNotApproved, setIdAddPhotoNotApproved] = useState();
  const [failureMessage, setFailureMessage] = useState();
  const [deletedPhotos, setDeletedPhotos] = useState([])
  const [deletedPhotosId, setDeletedPhotosId] = useState()
  const [deletedPhotosList, setDeletedPhotosList] = useState()
  const [deletedPhotoImg, setDeletedPhotoImg] = useState()

  useEffect(() => {
    if (!!roomPhotoApprovedToDB) {
      setPhotoApproved([{}, ...roomPhotoApprovedToDB])
    }
  }, [roomPhotoApprovedToDB])

  useEffect(() => {
    if (!!roomPhotoNotApprovedToDB) {
      setPhotoNotApproved(roomPhotoNotApprovedToDB)
    }
  }, [roomPhotoNotApprovedToDB])

  //состояние модалок, по дефолту скрыты
  const [show, toggleModalShow] = useState({
    addFailureMessageModal: false,
    failureModal: false,
    deletePhotoModal: false
  });

  /**
   * Проверка фотографии на идентичность
   */
  const isArrayEqual = useCallback((arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;

    for (let i = 0; i < arr1.length; i++) {
      if (!arr1[i]?.id || !arr2[i]?.id || arr1[i]?.id !== arr2[i]?.id) return false;
    }
    return true;
  }, []);

  /**
   * Обновление сортировки фотографии
   */
  const updatePhotoSort = (photoList) => {
    if (isArrayEqual(photoApproved.slice(1), photoList.slice(1))) return;

    setPhotoApproved(() => photoList)
    handleChangePhoto(photoList.slice(1))
  }

  //открытие/закрытие модалок
  const toggleShow = (modalName) => {
    toggleModalShow({ ...show, [modalName]: !show[modalName] })
  };

  //открывает модалку для указания причины отказа и добавляет ID отказаной фотографии
  const addToNotApproved = (photoId) => {
    toggleShow("addFailureMessageModal")
    setIdAddPhotoNotApproved(photoId)
  }

  //перносит фотографию в неподтверждениые и добавлет причину переноса
  const onSubmitFailure = (value) => {
    setPhotoApproved(() => photoApproved.filter(item => item.id !== addIdPhotoNotApproved))
    const NotApprovedPhotoFiltred = photoApproved.filter(item => item.id === addIdPhotoNotApproved)
    const newNotApprovedPhoto = { ...NotApprovedPhotoFiltred[0], "failure": value.failure }
    setPhotoNotApproved(() => [...photoNotApproved, newNotApprovedPhoto])
    toggleShow("addFailureMessageModal")

    handleChangePhoto(photoApproved.filter(item => item.id !== addIdPhotoNotApproved).slice(1))
    handleChangeRejectedPhoto && handleChangeRejectedPhoto([...photoNotApproved, newNotApprovedPhoto])
  }

  //открывает модалку для просмотра причины отказа
  const viewFalilureMessage = (message) => {
    setFailureMessage(message)
    toggleShow("failureModal")
  }

  //открывает модалку подтверждения удаления фото и указывае какую фото удалить
  const deletePhotoAcceptInModal = (photoId, photosList) => {
    setDeletedPhotosId(photoId)
    setDeletedPhotosList(photosList)

    let deletePhotoImg = null
    if (photosList === "photoApproved") {
      deletePhotoImg = photoApproved.filter(item => item.id === photoId)
    }
    if (photosList === "photoNotApproved") {
      deletePhotoImg = photoNotApproved.filter(item => item.id === photoId)
    }


    setDeletedPhotoImg(deletePhotoImg[0].src)
    toggleShow("deletePhotoModal")

  }

  //после подтверждения в модальном окне, удаляет из выбранного списка удаленную фотографию и сохраняет в список ID удаленных фотографий
  const deletePhoto = () => {
    if (deletedPhotosList === "photoApproved") {
      setPhotoApproved(() => photoApproved.filter(item => item.id !== deletedPhotosId))
    }
    if (deletedPhotosList === "photoNotApproved") {
      setPhotoNotApproved(() => photoNotApproved.filter(item => item.id !== deletedPhotosId))
    }
    setDeletedPhotos(() => [...deletedPhotos, deletedPhotosId])
    toggleShow("deletePhotoModal")


    handleChangePhoto(photoApproved.filter(item => item.id !== deletedPhotosId).slice(1))
    handleChangeRejectedPhoto && handleChangeRejectedPhoto(photoNotApproved.filter(item => item.id !== deletedPhotosId))
    handleChangeDeletedPhoto([...deletedPhotos, deletedPhotosId])
  }

  //перемещение фотографий из отказанных в опубликованные
  const removeToPhotoApproved = (photoId) => {
    setPhotoNotApproved(() => photoNotApproved.filter(item => item.id !== photoId))
    let approvedPhotoFiltred = photoNotApproved.filter(item => item.id === photoId)
    setPhotoApproved(() => [...photoApproved, { ...approvedPhotoFiltred[0] }])

    handleChangePhoto([...photoApproved, { ...approvedPhotoFiltred[0] }]);

    handleChangeRejectedPhoto && handleChangeRejectedPhoto(photoNotApproved.filter(item => item.id !== photoId));

  }

  const handleUnsavedPage = () => {
    handleChangePhoto(photoApproved.slice(1))
  }

  //добавить фотографии
  const uploadPhoto = async (e) => {
    const files = Array.from(e.target.files); // лучше сразу преобразовать в массив

    const processedFiles = files.map((file) => {
      return new Promise(async (resolve) => {
        // Проверка размера
        if ((file.size / 1024 / 1024) > 2) {
          setSizeAlert();
        }

        // Опции сжатия
        const resizeOptions = {
          maxSizeMB: 1,
          maxWidthOrHeight: 800,
          useWebWorker: true,
        };

        try {
          // Сжимаем файл
          const compressedFile = await imageCompression(file, resizeOptions);

          // Получаем Data URL сжатого файла
          const reader = new FileReader();
          reader.onload = () => {
            resolve({
              id: `new-${file.name}`,
              src: reader.result, // теперь это сжатое изображение
              file: compressedFile, // можно передавать на сервер
            });
          };
          reader.readAsDataURL(compressedFile); // читаем сжатый файл
        } catch (error) {
          console.error('Ошибка сжатия:', error);
          // Если ошибка, всё равно загружаем оригинал
          const reader = new FileReader();
          reader.onload = () => {
            resolve({
              id: `new-${file.name}`,
              src: reader.result,
              file,
            });
          };
          reader.readAsDataURL(file);
        }
      });
    });

    const res = await Promise.all(processedFiles);

    // Теперь `res` содержит только сжатые файлы или оригиналы в случае ошибки
    const photoApprovedNew = res.map(({ id, src }) => ({ id, src }));
    const rawFiles = res.map(({ file }) => file);

    setPhotoApproved((prev) => [...prev, ...photoApprovedNew]);
    handleChangePhoto([...photoApproved, ...photoApprovedNew].slice(1));
    handleChangeUploadPhoto(rawFiles); // передаем сжатые файлы
  };

  return (
    <>
      <div id="room-photo" className="section">
        <h5 className="card-title mb-2">Фотографии номера</h5>

        <Box className="alert alert-warning">
          Размер фотографий должен быть не менее 250x250 пикселей
        </Box>
        <Box className="alert alert-dark">
          Загружено {photoApproved?.length - 1} фото. Минимальное количество - 3, максимальное количество - 50
        </Box>
        <Collapse in={Boolean(errors?.photoCount)}>
          <Box className="alert alert-danger">
            {errors?.photoCount}
          </Box>
        </Collapse>

        <Collapse in={Boolean(errors?.photoSize)}>
          <Box className="alert alert-danger">
            {errors?.photoSize}
          </Box>
        </Collapse>


        {photoApproved && <RenderPhotoList photoApproved={photoApproved}
                                           updatePhotoSort={updatePhotoSort}
                                           addToNotApproved={addToNotApproved}
                                           deletePhotoAcceptInModal={deletePhotoAcceptInModal}
                                           uploadPhoto={uploadPhoto}
                                           baseUrl={baseUrl}
                                           handleUnsavedPage={handleUnsavedPage}
                                           userRole={userRole}/>}


        {photoNotApproved?.length > 0 && <div className="not-approv">
          <div className="alert alert-dark small">
            Отказано в публикации, {photoNotApproved?.length} фото:
          </div>

          <RenderNotApprovedFotoCard photoNotApproved={photoNotApproved}
                                     setPhotoNotApproved={setPhotoNotApproved}
                                     viewFalilureMessage={viewFalilureMessage}
                                     deletePhotoAcceptInModal={deletePhotoAcceptInModal}
                                     removeToPhotoApproved={removeToPhotoApproved}
                                     baseUrl={baseUrl}/>
        </div>}


      </div>

      {show.addFailureMessageModal &&
        <RenderModalAddFailureMessageModal toggleShow={() => toggleShow("addFailureMessageModal")}
                                           show={show.addFailureMessageModal}
                                           onSubmit={onSubmitFailure}/>}

      {show.failureModal && <RenderModalFailureMessage toggleShow={() => toggleShow("failureModal")}
                                                       show={show.failureModal}
                                                       failureMessage={failureMessage}/>}
      {show.deletePhotoModal && <RenderModalDeletePhoto toggleShow={() => toggleShow("deletePhotoModal")}
                                                        action={deletePhoto}
                                                        baseUrl={baseUrl}
                                                        show={show.deletePhotoModal}
                                                        deletedPhotoImg={deletedPhotoImg}/>}

    </>

  )
}


export default RoomPhoto;
